import { serializable, alias, primitive } from 'serializr';

export class AgreementStatusId {
	@serializable(alias('booking_id', primitive()))
	bookingId?: string;

	@serializable(alias('file_path', primitive()))
	filePath?: string;
}
